<!-- SwipFx Orders Page (Bootstrap 5) -->
<!-- Tabs need bootstrap.bundle.js -->
<div class="min-vh-100 bg-light">
    <app-header [page]="'Admin'"></app-header>

    <main class="container py-4">
        <div class="d-flex flex-wrap justify-content-between align-items-center gap-2 mb-3">
            <div>
                <h4 class="fw-bold mb-0">Payment Gateway Configs</h4>
                <div class="text-muted small">Manage encrypted gateway credentials and activation status</div>
            </div>

            <button class="btn btn-outline-secondary btn-sm" type="button" (click)="loadConfigs()">
                Refresh
            </button>
        </div>

        <div class="card shadow-sm border-0 mb-4">
            <div class="card-body">
                <div class="fw-semibold mb-3">Create Config</div>

                <form [formGroup]="createForm" (ngSubmit)="create()" class="row g-3">
                    <div class="col-md-4">
                        <label class="form-label">Provider</label>
                        <select class="form-select" formControlName="providerId">
                            <option value="">Select provider</option>
                            <option *ngFor="let p of providers" [value]="p.id">
                                {{ p.name }} ({{ p.code }})
                            </option>
                        </select>
                    </div>

                    <div class="col-md-4">
                        <label class="form-label">Config Name</label>
                        <input class="form-control" formControlName="name" placeholder="Flutterwave NGN Live">
                    </div>

                    <div class="col-md-4">
                        <label class="form-label">Environment</label>
                        <select class="form-select" formControlName="environment">
                            <option value="Live">Live</option>
                            <option value="Test">Test</option>
                        </select>
                    </div>

                    <div class="col-md-3">
                        <label class="form-label">Countries</label>
                        <select class="form-select" formControlName="countryCodes" multiple size="5">
                            <option *ngFor="let p of countries" [value]="p.code">
                                {{ p.name }} ({{ p.code }})
                            </option>
                        </select>
                        <div class="form-text">Hold Ctrl / Cmd to select multiple countries.</div>
                    </div>

                    <div class="col-md-3">
                        <label class="form-label">Public Key</label>
                        <input class="form-control" formControlName="publicKey">
                    </div>

                    <div class="col-md-3">
                        <label class="form-label">Secret Key</label>
                        <input class="form-control" formControlName="secretKey">
                    </div>

                    <div class="col-md-3">
                        <label class="form-label">Encryption Key</label>
                        <input class="form-control" formControlName="encryptionKey">
                    </div>

                    <div class="col-md-4">
                        <label class="form-label">Merchant Id</label>
                        <input class="form-control" formControlName="merchantId">
                    </div>

                    <div class="col-md-4">
                        <label class="form-label">Webhook Secret</label>
                        <input class="form-control" formControlName="webhookSecret">
                    </div>

                    <div class="col-md-4">
                        <label class="form-label">Base URL</label>
                        <input class="form-control" formControlName="baseUrl" placeholder="https://api.flutterwave.com">
                    </div>

                    <div class="col-12">
                        <div class="d-flex justify-content-between align-items-center mb-1">
                            <label class="form-label mb-0">Metadata Json</label>

                            <div class="d-flex gap-2" *ngIf="isBlaaizProvider(createForm.value.providerId)">
                                <button class="btn btn-sm btn-outline-primary" type="button"
                                    (click)="applyBlaaizMetadataTemplate('create')">
                                    Use stored Template
                                </button>
                                <button class="btn btn-sm btn-outline-secondary" type="button"
                                    (click)="formatMetadataJson('create')">
                                    Format JSON
                                </button>
                            </div>
                        </div>

                        <textarea class="form-control font-monospace" rows="8"
                            formControlName="metadataJson"></textarea>

                        <div class="form-text" *ngIf="isBlaaizProvider(createForm.value.providerId)">
                            Required for Blaaiz: interacEmail, cadWalletId, usdWalletId, gbpWalletId, eurWalletId, and
                            currency IDs.
                        </div>
                    </div>

                    <div class="col-12">
                        <button class="btn btn-primary" type="submit" [disabled]="createForm.invalid || submitting">
                            Save Config
                        </button>
                    </div>
                </form>
            </div>
        </div>

        <div class="card shadow-sm border-0 mb-3">
            <div class="card-body">
                <label class="form-label">Search</label>
                <input class="form-control" [(ngModel)]="search" (ngModelChange)="applyFilter()" name="configSearch"
                    placeholder="Search by provider, config, environment, country">
            </div>
        </div>

        <div class="card shadow-sm border-0">
            <div class="card-body">
                <div *ngIf="loading" class="text-muted">Loading configs...</div>

                <div class="table-responsive" *ngIf="!loading">
                    <table class="table align-middle">
                        <thead>
                            <tr>
                                <th>Provider</th>
                                <th>Config</th>
                                <th>Environment</th>
                                <th>Country</th>
                                <th>Public Key</th>
                                <th>Secret Key</th>
                                <th>Merchant Id</th>
                                <th>Status</th>
                                <th>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let item of filteredConfigs">
                                <td>
                                    <div class="fw-semibold">{{ item.providerName }}</div>
                                    <div class="small text-muted">{{ item.providerCode }}</div>
                                </td>
                                <td>{{ item.name }}</td>
                                <td>{{ item.environment }}</td>
                                <td>{{ item.countryCode || '-' }}</td>
                                <td>{{ item.publicKeyMasked || '-' }}</td>
                                <td>{{ item.secretKeyMasked || '-' }}</td>
                                <td>{{ item.merchantIdMasked || '-' }}</td>
                                <td>
                                    <span class="badge"
                                        [ngClass]="item.isActive ? 'text-bg-success' : 'text-bg-secondary'">
                                        {{ item.isActive ? 'Active' : 'Inactive' }}
                                    </span>
                                </td>
                                <td class="d-flex gap-2">
                                    <button class="btn btn-sm btn-outline-secondary" type="button"
                                        (click)="openEditModal(item)">
                                        Edit
                                    </button>

                                    <button class="btn btn-sm btn-outline-primary" type="button"
                                        (click)="toggleStatus(item)">
                                        {{ item.isActive ? 'Deactivate' : 'Activate' }}
                                    </button>
                                </td>
                            </tr>

                            <tr *ngIf="filteredConfigs.length === 0">
                                <td colspan="9" class="text-center text-muted">No configs found.</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>

        <app-footer></app-footer>
    </main>
</div>

<!-- Edit Config Modal -->
<div class="modal fade" id="editConfigModal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <form [formGroup]="editForm" (ngSubmit)="saveEdit()">
                <div class="modal-header">
                    <h5 class="modal-title">Edit Gateway Config</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>

                <div class="modal-body row g-3">
                    <div class="col-md-4">
                        <label class="form-label">Provider</label>
                        <select class="form-select" formControlName="providerId">
                            <option value="">Select provider</option>
                            <option *ngFor="let p of providers" [value]="p.id">
                                {{ p.name }} ({{ p.code }})
                            </option>
                        </select>
                    </div>

                    <div class="col-md-4">
                        <label class="form-label">Config Name</label>
                        <input class="form-control" formControlName="name">
                    </div>

                    <div class="col-md-4">
                        <label class="form-label">Environment</label>
                        <select class="form-select" formControlName="environment">
                            <option value="Live">Live</option>
                            <option value="Test">Test</option>
                        </select>
                    </div>

                    <div class="col-md-3">
                        <label class="form-label">Country Code</label>
                        <select class="form-select" formControlName="countryCode">
                            <option value="">Select Country</option>
                            <option *ngFor="let p of countries" [value]="p.code">
                                {{ p.name }} ({{ p.code }})
                            </option>
                        </select>
                    </div>

                    <div class="col-md-3">
                        <label class="form-label">Public Key</label>
                        <input class="form-control" formControlName="publicKey"
                            placeholder="Leave blank to keep existing">
                    </div>

                    <div class="col-md-3">
                        <label class="form-label">Secret Key</label>
                        <input class="form-control" formControlName="secretKey"
                            placeholder="Leave blank to keep existing">
                    </div>

                    <div class="col-md-3">
                        <label class="form-label">Encryption Key</label>
                        <input class="form-control" formControlName="encryptionKey" placeholder="Optional">
                    </div>

                    <div class="col-md-4">
                        <label class="form-label">Merchant Id</label>
                        <input class="form-control" formControlName="merchantId"
                            placeholder="Leave blank to keep existing">
                    </div>

                    <div class="col-md-4">
                        <label class="form-label">Webhook Secret</label>
                        <input class="form-control" formControlName="webhookSecret"
                            placeholder="Leave blank to keep existing">
                    </div>

                    <div class="col-md-4">
                        <label class="form-label">Base URL</label>
                        <input class="form-control" formControlName="baseUrl">
                    </div>

                    <div class="col-12">
                        <div class="d-flex justify-content-between align-items-center mb-1">
                            <label class="form-label mb-0">Metadata Json</label>

                            <div class="d-flex gap-2" *ngIf="isBlaaizProvider(editForm.value.providerId)">
                                <button class="btn btn-sm btn-outline-primary" type="button"
                                    (click)="applyBlaaizMetadataTemplate('edit')">
                                    Use Blaaiz Template
                                </button>
                                <button class="btn btn-sm btn-outline-secondary" type="button"
                                    (click)="formatMetadataJson('edit')">
                                    Format JSON
                                </button>
                            </div>
                        </div>

                        <textarea class="form-control font-monospace" rows="8"
                            formControlName="metadataJson"></textarea>

                        <div class="form-text" *ngIf="isBlaaizProvider(editForm.value.providerId)">
                            Required for Blaaiz: interacEmail, cadWalletId, usdWalletId, gbpWalletId, eurWalletId, and
                            currency IDs.
                        </div>
                    </div>

                    <div class="col-12">
                        <div class="form-check">
                            <input class="form-check-input" type="checkbox" formControlName="isActive"
                                id="editConfigIsActive">
                            <label class="form-check-label" for="editConfigIsActive">Active</label>
                        </div>
                    </div>
                </div>

                <div class="modal-footer">
                    <button type="button" class="btn btn-outline-secondary" data-bs-dismiss="modal">Cancel</button>
                    <button type="submit" class="btn btn-primary" [disabled]="editForm.invalid || modalSubmitting">
                        Save Changes
                    </button>
                </div>
            </form>
        </div>
    </div>
</div>